import { RightCircleFilled } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Store } from 'antd/lib/form/interface';
import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import zmenaEmailuPotvrzeniApi, { IZmenaEmailuResp } from 'services/zmenaEmailuPotvrzeni';

import routePathEnum from 'enums/routePathEnum';

interface IZmenaEmailuPotvrzeni {}

const ZmenaEmailuPotvrzeni: React.FC<IZmenaEmailuPotvrzeni> = () => {
    const [form] = useForm();
    const { language } = useContext(Context);
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState<boolean>(false);
    const [status, setStatus] = useState<number>(0);
    const [successMsg, setSuccessMsg] = useState<IZmenaEmailuResp['code']>();
    const onFinish = ({ username, password }: Store) => {
        setSuccessMsg(undefined);
        setLoading(val => !val);
        zmenaEmailuPotvrzeniApi(username, password, id!, language)
            .then(resp => {
                setStatus(resp.status);
                setSuccessMsg(resp.data.code);
            })
            .catch(err => setStatus(err.response.status))
            .finally(() => {
                setLoading(val => !val);
            });
    };
    const okReturn = () => (
        <div>
            <Row>
                <Col
                    span={24}
                    style={{
                        paddingBottom: 8
                    }}
                >
                    <Title
                        text={!successMsg ? 'EMP_POTVRZENI_EMAIL_SENT' : `EMP_POTVRZENI_EMAIL_200_${successMsg}`}
                        level={4}
                    />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <AnchorComponent link={true} to={routePathEnum.MAIN_PAGE}>
                        <ButtonComponent
                            buttontext="POKRACOVAT"
                            htmlType="button"
                            onClick={() => {
                                setStatus(0);
                                setSuccessMsg(undefined);
                            }}
                            id="emailOkRedirectBtn"
                        />
                    </AnchorComponent>
                </Col>
            </Row>
        </div>
    );

    const errReturn = () => (
        <div>
            <Row>
                <Col
                    span={24}
                    style={{
                        paddingBottom: 8
                    }}
                >
                    <Title text="EMP_POTVRZENI_EMAIL_401" level={4} />
                </Col>
                <Col span={24}>
                    <AnchorComponent link={true} to={routePathEnum.MAIN_PAGE}>
                        <ButtonComponent
                            buttontext="POKRACOVAT"
                            htmlType="button"
                            onClick={() => setStatus(0)}
                            id="emailErr401OkBtn"
                        />
                    </AnchorComponent>
                </Col>
            </Row>
        </div>
    );

    const err404Return = () => (
        <div>
            <Row>
                <Col
                    span={24}
                    style={{
                        paddingBottom: 8
                    }}
                >
                    <Title text="EMP_POTVRZENI_EMAIL_404" level={4} />
                </Col>
                <Col span={24}>
                    <ButtonComponent
                        buttontext="POKRACOVAT"
                        htmlType="button"
                        onClick={() => setStatus(0)}
                        id="emailErr404OkBtn"
                    />
                </Col>
            </Row>
        </div>
    );

    const defaultReturn = () => (
        <FormWrapper onFinish={onFinish} outForm={form}>
            <Title text="EMP_POTVRZENI_EMAIL_NADPIS" level={3} />{' '}
            <InputComponent
                label="UZIVATELSKE_JMENO"
                name="username"
                rules={[
                    {
                        type: 'email',
                        message: <TranslateText>NEVALIDNI_EMAIL</TranslateText>
                    }
                ]}
            />
            <InputComponent label="HESLO" name="password" type={'password'} />
            <ButtonComponent
                buttontext="POKRACOVAT"
                onClick={() => form.submit()}
                icon={<RightCircleFilled />}
                loading={loading}
                id="emailSubmitBtn"
                extramessage={successMsg === 'AUTENTIZACE' ? 'EMP_POTVRZENI_EMAIL_200_AUTENTIZACE' : ''}
            />
        </FormWrapper>
    );

    return (
        <AuthWrapper>
            {(!status || successMsg === 'AUTENTIZACE') && defaultReturn()}
            {status === 200 && successMsg && successMsg !== 'AUTENTIZACE' && okReturn()}
            {status === 401 && errReturn()}
            {status === 404 && err404Return()}
        </AuthWrapper>
    );
};

export default ZmenaEmailuPotvrzeni;
